/** @jsx jsx */
import { jsx } from '@emotion/react';
import { Styles } from './Styles';

export const SymbolSize24 = () => {
  return (
    <svg
      css={Styles.root}
      width="24"
      height="24"
      data-testid="ZapierLogoSymbolSmall"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z"
        fill="#FF4F00"
      />
    </svg>
  );
};
